import styled from 'styled-components';
import logo from '../../assets/images/logo-small.png';

const Div = styled.div`
      background-color: #53AEB4; 
      display: -webkit-flex; 
      display: flex; 
      align-items: center; 
      justify-content: center; 
      height: 50px; 
      width: 10vh; 
      cursor: pointer; 
      :focus{
        outline:none;
      }
    `;
const Image = styled.img({ height: '28px' });

export function HeaderLogo() {
  return (
    <Div><a href={`${process.env.REACT_APP_PAGES_URL}/myreports/`}><Image src={logo} /></a></Div>
  );
}
